import React, { useState, useEffect } from 'react';

const ImageWithLoader = ({ 
  src, 
  alt, 
  className = '', 
  placeholderColor = '#f0f0f0',
  showSpinner = true,
  ...props 
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    setError(false);
    
    // Preload image
    const img = new Image();
    img.src = src;
    
    img.onload = () => {
      setImageSrc(src);
      setIsLoading(false);
    };
    
    img.onerror = () => {
      setError(true);
      setIsLoading(false);
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  if (error) {
    return (
      <div 
        className={`flex items-center justify-center bg-gray-200 ${className}`}
        style={{ backgroundColor: placeholderColor }}
      >
        <p className="text-gray-500 text-sm">Failed to load image</p>
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Loading Placeholder */}
      {isLoading && (
        <div 
          className={`absolute inset-0 flex items-center justify-center animate-pulse ${className}`}
          style={{ backgroundColor: placeholderColor }}
        >
          {showSpinner && (
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2" style={{ borderColor: '#D4AF37' }}></div>
          )}
        </div>
      )}
      
      {/* Actual Image */}
      <img
        src={imageSrc}
        alt={alt}
        className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
        loading="lazy"
        {...props}
      />
    </div>
  );
};

export default ImageWithLoader;
